module.exports = " <h4 class=small-heading _v-e68c6098=\"\"> <slot _v-e68c6098=\"\"></slot> </h4> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-e68c6098!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/SmallHeading.vue
// module id = 766
// module chunks = 2